export const TAB_IDS = {
  SALES: "sales",
  BOOTHS: "booths",
  SPONSORSHIPS: "sponsorships",
  REQUESTS: "requests",
  APPROVERS: "approvers",
  SEND_EMAILS: "send-emails"
};
